module.exports = __webpack_public_path__ + "static/media/imgEmojiOops@2x.6ebd9d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgEmojiOops@2x.png
// module id = 366
// module chunks = 22